import React from 'react';
import { useLocation } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { SEOLink } from './SEOLink';
import { primaryFor } from '../../data/intentConsolidation';

/**
 * PrimaryIntentNotice — Sprint A consolidation signal.
 * On a duplicate-intent page, points crawlers and readers at the one URL that
 * owns the intent. No page is removed, redirected or de-indexed.
 */
export const PrimaryIntentNotice = () => {
  const { pathname } = useLocation();
  const primary = primaryFor(pathname);
  if (!primary) return null;

  return (
    <section className="py-10 bg-slate-50 border-t border-slate-200" data-testid="primary-intent-notice">
      <div className="max-w-4xl mx-auto px-4">
        <div className="rounded-2xl border border-slate-200 bg-white p-6 md:flex md:items-center md:justify-between md:gap-6">
          <p className="text-slate-600 text-sm leading-relaxed mb-4 md:mb-0">
            {primary.note || 'Looking for the full service page for this topic?'}
          </p>
          <SEOLink
            to={primary.to}
            className="inline-flex items-center gap-2 shrink-0 rounded-full bg-red-600 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-red-700"
            data-testid="primary-intent-link"
          >
            {primary.anchor}
            <ArrowRight className="h-4 w-4" />
          </SEOLink>
        </div>
      </div>
    </section>
  );
};

export default PrimaryIntentNotice;
